export const COMMON_POPPER_MODIFIERS = [
  {
    name: 'flip',
    enabled: true,
    options: {
      altBoundary: true,
      rootBoundary: 'document',
    },
  },
  {
    name: 'preventOverflow',
    enabled: true,
    options: {
      altAxis: true,
      altBoundary: true,
      tether: true,
      boundary: 'document',
      padding: 8,
    },
  },
  {
    name: 'offset',
    options: {
      offset: [0, 10],
    },
  },
];
